import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgSpinner = function SvgSpinner(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#spinner_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.325 12A7.675 7.675 0 1112 19.675a7.638 7.638 0 01-3.2-.697 2.163 2.163 0 00-1.807 3.93A11.963 11.963 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12a2.163 2.163 0 004.325 0z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "spinner_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgSpinner;